module.exports = __webpack_public_path__ + "img/能力体系W.4e7f57a2.svg";